import type { InjectedRouter } from 'js/lib/connectToRouter';

type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;

/* eslint-disable @typescript-eslint/no-empty-function */
export default function (stubs?: DeepPartial<InjectedRouter>): InjectedRouter {
  const routerStub: InjectedRouter = {
    // https://github.com/reactjs/react-router/blob/12d26c0/docs/API.md#contextrouter
    push: () => {},
    replace: () => {},
    go: () => {},
    goBack: () => {},
    goForward: () => {},
    createPath: () => '',
    createHref: () => '',

    setRouteLeaveHook: () => () => {},
    isActive: () => false,

    // This is the `params` prop normally provided only to the Route component.
    params: {},
    routes: [],

    // This is a LocationDescriptor from the `history` module.
    // This is normally provided only to the Route component, but we're encapsulating it on context.
    // https://github.com/mjackson/history/blob/e491c96/docs/Glossary.md#locationdescriptor
    location: {
      pathname: '',
      search: '',
      query: {},
      state: '',
      action: 'PUSH',
      key: '',
    },
    components: [],
  };

  Object.assign(routerStub, stubs);

  return routerStub;
}
